// src/dashboard-cliente/Downloads.js
import React, { useEffect, useState } from 'react';
import './estilodashuser.css';
import api from '../api';

const Downloads = () => {
  const [arquivos, setArquivos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchArquivos = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/arquivos');
        setArquivos(response.data || []);
      } catch (error) {
        console.error('Erro ao listar arquivos para download:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchArquivos();
  }, []);

  return (
    <div className="container-suporte">
      <h2>Downloads</h2>
      <p>
        Aqui você encontra o robô <strong>Quantum Trades EA</strong>, templates,
        manuais e outros arquivos necessários para instalação e operação.
      </p>

      {loading && <p>Carregando arquivos...</p>}

      {!loading && arquivos.length === 0 && (
        <p>Nenhum arquivo disponível no momento.</p>
      )}

      {!loading && arquivos.length > 0 && (
        <ul>
          {arquivos.map((nome, index) => (
            <li key={index}>
              <a
                href={`https://quantumtrades.com.br:8080/downloads/${nome}`}
                download
              >
                {nome}
              </a>
            </li>
          ))}
        </ul>
      )}

      {/* Observação legal */}
      <div
        style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#f8f9fa',
          border: '1px solid #ddd',
          borderRadius: '6px',
          fontSize: '14px',
        }}
      >
        <strong>Observação importante:</strong>

        <p style={{ marginTop: '10px' }}>
          Os setups, parâmetros e arquivos compartilhados nesta área não são de
          responsabilidade da <strong>Quantum Trades</strong>. A utilização
          destes materiais é de <strong>inteira responsabilidade do USUÁRIO</strong>,
          sendo feita por sua conta e risco.
        </p>

        <p>
          Resultados exibidos em backtests, demonstrações, portfólios e simulações
          são apenas estimativas e <strong>não representam garantia de desempenho futuro</strong>.
        </p>

        <p>
          O USUÁRIO reconhece que operações no mercado Forex, índices e demais
          derivativos envolvem <strong>riscos significativos</strong>, podendo
          resultar em perdas superiores ao capital investido.
        </p>

        <p>
          <strong>
            É proibida a distribuição, cópia, venda, compartilhamento ou uso do
            robô em qualquer sistema de terceiros sem autorização expressa da
            Quantum Trades.
          </strong>
        </p>
      </div>
    </div>
  );
};

export default Downloads;
